import styled from 'styled-components';

import { ModalBody } from '../../../../../components/DialogRoundedModal';
import colors from '../../../../../styles/colors';

const ModalContent = styled(ModalBody)`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const DataGridContainer = styled.div`
  height: 520px;
  width: 100%;

  .MuiDataGrid-columnHeaderCheckbox .MuiCheckbox-root {
    display: none;
  }
`;

const NameCell = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const HelperText = styled.div`
  font-size: 13px;
  color: ${({ $warning }) => ($warning ? colors.base.warning : colors.shades.gamma10)};
`;

export {
  ModalContent,
  DataGridContainer,
  NameCell,
  HelperText,
};
